import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { IPermitTypeField } from '~/client/graph'
import IPermitFieldsStore from '~/client/src/shared/models/IPermitFieldsStore'
import InitialState from '~/client/src/shared/stores/InitialState'

import SitePermitCreationFormStore from '../../WorkflowCreationForm.store'
import PermitFormUserField from './PermitFormUserField'

interface IProps {
  typeField: IPermitTypeField
  isViewMode: boolean
  shouldHideResponsible: boolean

  store: SitePermitCreationFormStore
  fieldsStore: IPermitFieldsStore

  state?: InitialState
}

@inject('state')
@observer
export default class PermitFormRequesterField extends React.Component<IProps> {
  public render() {
    const { isViewMode, store, typeField, shouldHideResponsible, state } =
      this.props
    const { isMultiple } = typeField
    const { user: currentUser } = state
    const {
      editablePermit: { responsibleIds },
      isResponsibleShown,
    } = store

    const areRequesterAndResponsibleCurrentUser =
      !isMultiple &&
      responsibleIds?.includes(currentUser.id) &&
      this.fieldValues.includes(currentUser.id)

    if (
      areRequesterAndResponsibleCurrentUser &&
      shouldHideResponsible &&
      isResponsibleShown &&
      !isViewMode
    ) {
      return null
    }

    return <PermitFormUserField {...this.props} />
  }

  private get fieldValues(): string[] {
    const { typeField, fieldsStore } = this.props
    const values = fieldsStore.getFieldValues<string>(typeField.id)
    return values?.length ? values : ['']
  }
}
